import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  ListItem,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import BusinessIcon from "@material-ui/icons/Business";
import ChatIcon from "@material-ui/icons/Chat";
import InfoIcon from "@material-ui/icons/Info";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SortableTable from "../../Components/SortableTable";
import Title from "../../Components/Title";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  ECABIN,
  formatTimeWithTZOffset,
  getInvoiceIssuerData,
  getInvoiceIssuerOptions,
  getInvoiceIssuers,
  getToken,
  getUser,
  invoiceIssuerMatchesValue,
  paymentStates,
  requestErrorHandler,
  searchMatchingList,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import EditOrder from "./EditOrder";
import NewOrder from "./NewOrder";

const server = EnvSettings.server;

export default function ResupplyOrders(props) {
  const order_id = props?.computedMatch?.params?.order_id;
  const classes = useStyles();
  const [searchList, setSearchList] = useState();
  const [orderList, setOrderList] = useState();
  const [searchValue, setSearchValue] = useState(() => order_id || "");
  const [filterStates, setFilterStates] = useState(() =>
    order_id
      ? paymentStates.map((m) => m.value)
      : ["invoiced", "deposit", "completed", "transit"],
  );
  const [selectedOrder, setSelectedOrder] = useState();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [buyerCompany, setBuyerCompany] = useState();
  const [invoiceIssuers, setInvoiceIssuers] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    getInvoiceIssuers(setInvoiceIssuers, dispatch);
  }, [dispatch]);

  const editBoxRef = useRef(null);

  const executeScroll = () => {
    editBoxRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const showOrder = (dev) => {
    setSelectedOrder();
    // Hack for refreshing the selected device component
    setTimeout(() => {
      setSelectedOrder(dev);
      if (editBoxRef && editBoxRef.current) {
        executeScroll();
      }
    }, 1);
  };

  const getResupplyOrders = (ser_val) => {
    setLoading(true);
    setSearchList();
    setSelectedOrder();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
      }),
    };
    fetch(server + "/get_resupply_orders", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setOrderList(result.orders);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  // useEffect(getOrders, []);

  const filterResults = () => {
    setSearchList(
      orderList &&
        orderList.filter((contact) => {
          return (
            filterStates.find((o) => o === contact.paymentStatus) &&
            searchMatchingList(
              [
                contact.number,
                contact.genericDevices,
                contact.User,
                contact.invoiceIssuer,
                contact.SupplierCompany,
              ],
              searchValue,
            ) &&
            invoiceIssuerMatchesValue(contact.buyer, buyerCompany)
          );
        }),
    );
  };

  useEffect(filterResults, [
    searchValue,
    orderList,
    filterStates,
    buyerCompany,
    invoiceIssuers,
  ]);

  useEffect(getResupplyOrders, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <NewOrder />
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                startIcon={<BusinessIcon />}
                onClick={() => {
                  history.push("/cpanel/resupply/suppliers");
                }}
              >
                {t("resupplyOrders.supplierCompanies")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper} style={{ overflow: "hidden" }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item container spacing={3} xs={12}>
              <Grid item xs={12}>
                <Title>{t("resupplyOrders.header")}</Title>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                autoFocus
                label={t("search")}
                type="text"
                fullWidth
                variant="outlined"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value.toLowerCase());
                }}
                ref={editBoxRef}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label={t("resupplyOrders.buyer")}
                variant="outlined"
                select
                fullWidth
                onChange={(e) => {
                  setBuyerCompany(e.target.value);
                }}
              >
                {[
                  { name: "", data: { name: t("select") } },
                  ...getInvoiceIssuerOptions(invoiceIssuers),
                ].map((m, i) => (
                  <MenuItem key={(m.name || "select") + i} value={m.name}>
                    {m?.data?.name || t("select")}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <EditOrder selectedOrder={selectedOrder} />
          {searchList ? (
            <>
              <Grid container item xs={12}>
                <Grid item xs={11}>
                  <Typography>{t("orders.paymentStatus")}</Typography>
                  {paymentStates
                    .filter((f) => f.value !== "waiting")
                    .map((o) => (
                      <FormControlLabel
                        key={o.label}
                        control={
                          <Checkbox
                            color={o.color || "primary"}
                            style={{ color: o.color || "" }}
                            onChange={(e, v) => {
                              if (v) {
                                setFilterStates([...filterStates, o.value]);
                                return;
                              }
                              setFilterStates([
                                ...filterStates.filter((f) => f !== o.value),
                              ]);
                            }}
                            defaultChecked={
                              !!filterStates.find((f) => f === o.value)
                            }
                          />
                        }
                        label={t("paymentStates." + o.value)}
                      />
                    ))}
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <SortableTable
                tableLayout={"fixed"}
                downloadButton={true}
                header={t("resupplyOrders.header")}
                headCells={[
                  {
                    id: "Notes",
                    label: "",
                    width: 32,
                    hideFromCsv: true,
                  },
                  {
                    id: "EmailListResupplyOrders",
                    label: "",
                    width: 32,
                    hideFromCsv: true,
                  },
                  {
                    id: "updatedAt",
                    numeric: false,
                    disablePadding: false,
                    label: t("updatedAt"),
                  },
                  {
                    id: "createdAt",
                    numeric: false,
                    disablePadding: false,
                    label: t("createdAt"),
                  },
                  {
                    id: "User.fullName",
                    numeric: false,
                    disablePadding: false,
                    label: t("createdBy"),
                  },
                  {
                    id: "buyer",
                    numeric: false,
                    disablePadding: false,
                    label: t("resupplyOrders.buyer"),
                  },
                  {
                    id: "invoiceIssuer",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.invoiceIssuer"),
                  },
                  {
                    id: "number",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.orderNumber"),
                  },
                  {
                    id: "paymentStatus",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.paymentStatus"),
                  },
                  {
                    id: "genericDevices",
                    numeric: false,
                    disablePadding: false,
                    label: t("items"),
                  },
                  {
                    id: "totalPrice",
                    numeric: false,
                    disablePadding: false,
                    label: t("orders.totalPrice"),
                  },
                ]}
                // disablePagination: true,
                defaultSortRow={"updatedAt"}
                handleRowClick={showOrder}
                getRowStyle={(data) => {
                  var obj = { cursor: "pointer" };
                  var p = paymentStates.find(
                    (f) => data.paymentStatus === f.value,
                  );
                  if (p && p.color) {
                    return { ...obj, backgroundColor: p.color };
                  }
                  return obj;
                }}
                specialDataFormatting={[
                  {
                    id: "updatedAt",
                    format: (data, d, dd) => {
                      if (dd.Notes && dd.Notes.length) {
                        const max = dd.Notes.reduce((prev, current) =>
                          prev && prev.id > current.id ? prev : current,
                        );
                        return formatTimeWithTZOffset(max.updatedAt, ECABIN);
                      }
                      return formatTimeWithTZOffset(data, ECABIN);
                    },
                  },
                  {
                    id: "invoiceIssuer",
                    format: (data, d, dd) => {
                      if (dd.SupplierCompany) {
                        return dd.SupplierCompany.name;
                      }
                      return data;
                    },
                  },
                  {
                    id: "Notes",
                    format: (data) => {
                      if (data.find((f) => f.User)) {
                        return (
                          <Tooltip title={t("activeComments")}>
                            <ChatIcon
                              color="primary"
                              style={{ fontSize: 20 }}
                            />
                          </Tooltip>
                        );
                      }
                      return "";
                    },
                  },
                  {
                    id: "EmailListResupplyOrders",
                    format: (data, d, dd) => {
                      if (
                        (data &&
                          data.find(
                            (f) =>
                              f &&
                              f.EmailList?.EmailListUsers.find(
                                (u) => u.User.id === getUser().userId,
                              ),
                          )) ||
                        dd.UserId === getUser().userId
                      ) {
                        return (
                          <Tooltip title={t("tagged")}>
                            <NotificationsIcon
                              color="primary"
                              style={{ fontSize: 20 }}
                            />
                          </Tooltip>
                        );
                      }
                      return "";
                    },
                  },
                  {
                    id: "createdAt",
                    format: (data) => {
                      return formatTimeWithTZOffset(data, ECABIN);
                    },
                  },
                  {
                    id: "genericDevices",
                    format: (data) => {
                      if (data && data.length > 1) {
                        var x = 0;
                        data.forEach((d) => (x = x + d.count));
                        return t("count") + ":" + x;
                      }
                      var a = "";
                      data.forEach((v) => (a = v.count + " x " + v.name));
                      return a;
                    },
                  },
                  {
                    id: "paymentStatus",
                    formatReturnsElement: true,
                    format: (data, e, v) => {
                      if (e === "json") {
                        return t(
                          "paymentStates." +
                            paymentStates.find((o) => o.value === data).value,
                        );
                      }
                      return (
                        <ListItem>
                          {t(
                            "paymentStates." +
                              paymentStates.find((o) => o.value === data).value,
                          )}
                          {data === "transit" && v.multipleShipments ? (
                            <Tooltip
                              title={t("orders.multipleShipments")}
                              placement="top"
                            >
                              <ListItemIcon size="small">
                                <InfoIcon
                                  style={{ verticalAlign: "middle" }}
                                  fontSize="small"
                                />
                              </ListItemIcon>
                            </Tooltip>
                          ) : null}
                        </ListItem>
                      );
                    },
                  },
                  {
                    id: "buyer",
                    format: (data) => {
                      if (!data) {
                        return data;
                      }
                      return (
                        getInvoiceIssuerData(invoiceIssuers, data)?.name || data
                      );
                    },
                  },
                ]}
                // handleScrollClick: showDeviceNewTab,
                tableData={searchList}
                rowsPerPage={50}
              />
            </>
          ) : loading ? (
            <CircularProgress />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}
